<template>
    <div class="first-profile-form">
        <section>
            <div class="level">
                <div class="level-item">
                    <figure class="image is-256x256" v-if="profileImage !== null || formData.profilePhotoUrl !== null">
                        <img :src="profileImage ? profileImage : formData.profilePhotoUrl" alt="Profile Image"
                             style="width: 256px; height: auto;">
                    </figure>
                </div>
            </div>
            <div class="level">
                <div class="level-item">
                    <label class="label">อัพโหลดรูปของน้อง (รูปถ่ายหน้าตรง ไม่สวมหมวก ถ่ายไว้ไม่เกิน 6 เดือน)</label>
                </div>
            </div>
            <div class="level">
                <div class="level-item">
                    <div class="file">
                        <label class="label"></label>
                        <label class="file-label">
                            <input class="file-input" type="file" name="resume" @change="onFileChange">
                            <span class="file-cta">
                                <span class="file-icon">
                                    <i class="fas fa-upload"></i>
                                </span>
                                <span class="file-label">
                                    Choose a file…
                                </span>
                            </span>
                        </label>
                    </div>
                </div>
            </div>
            <section class="field">
                <div class="control">
                    <label class="label">
                        เพศ
                    </label>
                    <label class="radio">
                        <input type="radio" name="answer" v-model="formData.gender" value="นาย">
                        นาย
                    </label>
                    <label class="radio">
                        <input type="radio" name="answer" v-model="formData.gender" value="นางสาว">
                        นางสาว
                    </label>
                </div>
            </section>
            <section class="columns">
                <div class="column">
                    <div class="field">
                        <label class="label">ชื่อจริง</label>
                        <div class="control">
                            <input class="input" type="text" placeholder="ชื่อจริง" v-model="formData.firstName">
                        </div>
                    </div>
                </div>

                <div class="column">
                    <div class="field">
                        <label class="label">นามสกุล</label>
                        <div class="control">
                            <input class="input" type="text" placeholder="นามสกุล" v-model="formData.lastName">
                        </div>
                    </div>
                </div>
            </section>

            <section class="columns">
                <div class="column">
                    <div class="field">
                        <label class="label">ชื่อเล่น</label>
                        <div class="control">
                            <input class="input" type="text" placeholder="ชื่อเล่น" v-model="formData.nickName">
                        </div>
                    </div>
                </div>

                <div class="column">
                    <div class="field">
                        <label class="label">วันเกิด (วว/ดด/ปปปป)</label>
                        <datepicker v-model="formData.birthDate"
                                    input-class="input"
                                    placeholder="เลือกวันที่"
                                    wrapper-class="control"
                        ></datepicker>
                    </div>
                </div>
            </section>
            <section class="columns">
                <div class="column">
                    <div class="field">
                        <label class="label">อายุ</label>
                        <div class="control">
                            <input class="input" type="number" placeholder="อายุ" v-model="formData.age">
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field">
                        <label class="label">Facebook (ถ้ามี)</label>
                        <div class="control">
                            <input class="input" type="text" placeholder="Facebook" v-model="formData.facebook">
                        </div>
                    </div>
                </div>
            </section>
            <section class="columns">
                <div class="column">
                    <div class="field">
                        <label class="label">LINE ID</label>
                        <div class="control">
                            <input class="input" type="text" placeholder="LINE ID" v-model="formData.lineId">
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field">
                        <label class="label">Email</label>
                        <div class="control">
                            <input class="input" type="email" placeholder="Email" v-model="formData.email">
                        </div>
                    </div>
                </div>
            </section>
            <section class="columns">
                <div class="column">
                    <div class="field">
                        <label class="label">เบอร์โทรศัพท์มือถือ</label>
                        <div class="control">
                            <input class="input" type="text" placeholder="เบอร์โทรศัพท์มือถือ"
                                   v-model="formData.mobileNumber">
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field">
                        <label class="label">เบอร์โทรศัพท์บ้าน</label>
                        <div class="control">
                            <input class="input" type="text" placeholder="เบอร์โทรศัพท์บ้าน"
                                   v-model="formData.homeNumber">
                        </div>
                    </div>
                </div>
            </section>
            <section class="columns">
                <div class="column">
                    <div class="field">
                        <label class="label">ชื่อผู้ปกครอง</label>
                        <div class="control">
                            <input class="input" type="text" placeholder="ชื่อผู้ปกครอง"
                                   v-model="formData.parent">
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field">
                        <label class="label">ความสัมพันธ์กับผู้ปกครอง</label>
                        <div class="control">
                            <input class="input" type="text" placeholder="ความสัมพันธ์กับผู้ปกครอง"
                                   v-model="formData.relationshipWithParent">
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field">
                        <label class="label">เบอร์ติดต่อผู้ปกครอง</label>
                        <div class="control">
                            <input class="input" type="text" placeholder="เบอร์ติดต่อผู้ปกตรอง"
                                   v-model="formData.parentMobilePhoneNumber">
                        </div>
                    </div>
                </div>
            </section>
        </section>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';

    export default {
        name: "FirstProfileForm",
        components: {Datepicker},
        data: function () {
            return {
                formData: {},
                profileImage: null
            }
        },
        methods: {
            onFileChange(e) {
                const files = e.target.files || e.dataTransfer.files;
                if (!files.length) return;
                this.createImage(files[0]);
                return this.$store.dispatch('setUserProfilePhoto', files[0]);
            },
            createImage(file) {
                let reader = new FileReader();

                reader.onload = (e) => {
                    this.profileImage = e.target.result;
                };
                reader.readAsDataURL(file);
            },
        },
        watch: {
            userFormDataState(newFormState) {
                if (newFormState['birthDate'] !== null && !(newFormState['birthDate'] instanceof Date)) {
                    newFormState['birthDate'] = newFormState['birthDate'].toDate();
                }
                this.formData = newFormState;
            },
            async formValue() {
                await this.$store.dispatch('setUserFormData', this.formData);
            }
        },
        computed: {
            formValue() {
                return Object.values(this.formData);
            },
            userFormDataState() {
                return this.$store.getters.userFormData;
            },
        },
    }
</script>

<style scoped>
    #fileInput {
        display: none;
    }
</style>
